import React from 'react';
import './pageHeader.module.scss';

type Props = {
  title: string;
  testId: string;
};

// HOME/COURSES/HOMEWORK...など各ページに表示される見出し
export const PageHeader = ({ title, testId }: Props) => {
  return (
    <div styleName="page-header" data-testid={testId}>
      <div styleName="title">{title}</div>
    </div>
  );
};
